import Search, { getStaticProps as getStaticSearchProps } from '../components/pages/Search';

export default Search;

export const getStaticProps = getStaticSearchProps;
